import {
  axiosGetWithCookies,
  axiosPostWithCookies,
  axiosPutWithCookies,
} from './helper';
import Config from 'config';
import axios from 'axios';
import { endOfDay, startOfDay } from '../utils/time';

export const fetchPatrolDefList = ({
  archived,
  securityCompanyId,
  site,
  businessClient,
  search,
  proximityAlertDisabled,
  departmentId,
}) => {
  let query = `/patrols/patrols/definitions?sort=definitionName:asc&securityCompanyId=${securityCompanyId}&limit=50`;

  if (businessClient) query += `&businessClientId=${businessClient}`;
  if (site) query += `&siteId=${site}`;
  if (search) query += `&search=${search}`;
  if (archived) query += `&includeArchived=${archived}`;
  if (proximityAlertDisabled)
    query += `&proximityAlertDisabled=${proximityAlertDisabled}`;
  if (departmentId === 'EMPTY_VALUE') {
    query += `&departmentId=${'EMPTY_VALUE'}`;
  } else if (departmentId) {
    query += `&departmentId=${departmentId}`;
  }
  return axiosGetWithCookies(query);
};

export const fetchPatrolDefDetails = id =>
  axiosGetWithCookies(`/patrols/patrols/definitions/${id}`);

export const addPatrolDef = patrolDef =>
  axiosPostWithCookies(`/patrols/patrols/definitions`, {
    data: patrolDef,
  });

export const updatePatrolDef = (id, patrolDef) =>
  axiosPutWithCookies(`/patrols/patrols/definitions/${id}`, {
    data: patrolDef,
  });

export const getPatrolQr = id =>
  axiosGetWithCookies(`/patrols/patrols/definitions/${id}/pdf`);

export const getLocationImage = ({ size, mapType, markers }) => {
  const url = `https://maps.googleapis.com/maps/api/staticmap?size=${size}&maptype=${mapType}&${markers}&key=${Config.googleApiKey}`;

  return axios.get(url, { responseType: 'arraybuffer' });
};

export const fetchPatrolDashboard = ({
  securityCompanyId,
  dateFrom,
  dateTo,
  search,
  from,
  timezone,
}) => {
  let query = `/patrols/dashboard?sort=companyName:asc&limit=50`;
  if (from) query += `&from=${from}`;
  if (securityCompanyId) query += `&securityCompanyId=${securityCompanyId}`;
  if (search) query += `&search=${search}`;
  if (dateFrom) {
    const startFrom = startOfDay({
      date: dateFrom,
      timezone: timezone || 'UTC',
    });
    query += `&fromDate=${startFrom}`;
  }
  if (dateTo) {
    const endAt = endOfDay({
      date: dateTo,
      timezone: timezone || 'UTC',
    });
    query += `&toDate=${endAt}`;
  }
  return axiosGetWithCookies(query);
};
